import styled from 'styled-components';

export const ButtonGroup = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
	margin-top: 1rem;

	@media (max-width: 768px) {
		flex-direction: column;
		gap: 0.5rem;
	}
`;
